module.exports = __webpack_public_path__ + "static/media/bg1.10be69d5.jpg";